module.exports = __webpack_public_path__ + "img/rushan_2.70682194.jpeg";